document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.custom-menu-toggle');
  const mobileMenu = document.querySelector('.custom-mega-mobile');
  const overlay = document.querySelector('.custom-menu-overlay');
  const close = document.querySelector('.custom-menu-close');
  const accordionTriggers = document.querySelectorAll('.custom-mega-mobile__trigger');
  const desktopTriggers = document.querySelectorAll('.custom-mega-desktop__trigger');

  function updateMegaMenuPosition() {
    const header =
      document.querySelector('header.header') ||
      document.querySelector('.shopify-section-header') ||
      document.querySelector('#shopify-section-header');

    if (!header) return;

    const headerPosition = header.getBoundingClientRect();
    const headerBottom = Math.ceil(headerPosition.bottom);

    document.documentElement.style.setProperty(
      '--mega-menu-dynamic-top',
      headerBottom + 'px'
    );
  }

  updateMegaMenuPosition();

  window.addEventListener('scroll', updateMegaMenuPosition);
  window.addEventListener('resize', updateMegaMenuPosition);

  desktopTriggers.forEach(function (trigger) {
    trigger.addEventListener('mouseenter', updateMegaMenuPosition);
    trigger.addEventListener('focus', updateMegaMenuPosition);
  });

  if (!toggle || !mobileMenu) return;

  function openMenu() {
    mobileMenu.classList.add('is-open');

    if (overlay) {
      overlay.classList.add('is-open');
    }

    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileMenu.classList.remove('is-open');

    if (overlay) {
      overlay.classList.remove('is-open');
    }

    document.body.style.overflow = '';
  }

  toggle.addEventListener('click', openMenu);

  if (close) {
    close.addEventListener('click', closeMenu);
  }

  if (overlay) {
    overlay.addEventListener('click', closeMenu);
  }

  accordionTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      const item = trigger.closest('.custom-mega-mobile__item');

      if (!item) return;

      item.classList.toggle('is-open');
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeMenu();
    }
  });
});

 